import configuration from './Main';
export default configuration;
